import { ComponentType } from 'react'
import { AdvertiserIcon } from './AdvertiserIcon'
import { AffiliateIcon } from './AffiliateIcon'
import { BrowserIcon } from './BrowserIcon'
import { CityIcon } from './CityIcon'
import { CountryIcon } from './CountryIcon'
import { DateIcon } from './DateIcon'
import { DomainIcon } from './DomainIcon'
import { KeywordIcon } from './KeywordIcon'
import { PolicyIcon } from './PolicyIcon'
import { ProjectIcon } from './ProjectIcon'
import { SearchEngineIcon } from './SearchEngineIcon'
import { TagIcon } from './TagIcon'
import { UrlIcon } from './UrlIcon'

/** Иконка фильтра по имени поля формы — одно и то же поле на разных экранах зовётся по-разному */
export const FILTER_ICONS: Record<string, ComponentType> = {
  adDomain: DomainIcon,
  advertiser: AdvertiserIcon,
  advertiserName: AdvertiserIcon,
  affiliate: AffiliateIcon,
  browser: BrowserIcon,
  city: CityIcon,
  country: CountryIcon,
  date: DateIcon,
  dateRange: DateIcon,
  domain: DomainIcon,
  engine: SearchEngineIcon,
  engine_id: SearchEngineIcon,
  keyword: KeywordIcon,
  landing: UrlIcon,
  page_url: UrlIcon,
  policy: PolicyIcon,
  project: ProjectIcon,
  site: DomainIcon,
  tags: TagIcon,
  url: UrlIcon,
}
